<div class="seperator"></div>
<div class="title" mat-dialog-title>Enable Blis</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">Please schedule a daily Blis report and send to below email: </div>
        <div class="ias-email">
            {{blisEmail}}
        </div>
    </div>
</div>
<div class="dialog-footer">
    <div>
    </div>
</div>